<template>
    <div>
        <van-nav-bar class="header" :title="activityTheme" left-arrow @click-left="onClickLeft" fixed/>
        <div class="form-box">
            <table-grid meta-id="1" :data-id="customerId" :hidden-fields="hiddenFields" :grouping="grouping" v-if="loaded"></table-grid>
        </div>
    </div>
</template>

<script>
    import {NavBar} from 'vant';
    import activityListService from "../../service/activityListService";
    export default {
        data: function () {
            return {
                activityTheme:'信息详情',
                customerId:'',
                grouping: false,
                hiddenFields: [],
            }
        },
        components: {
            [NavBar.name]: NavBar,
        },
        computed: {
            loaded: function () {  //用于请求异步加载完成，hiddenFields数组长度肯定大于0，因此 length > 0 可以作为加载完毕的标识
                return this.hiddenFields.length > 0;
            }
        },
        mounted: async function() {
            this.customerId = this.$route.query.id;
            let resp = await activityListService.getHiddenFields(this.$route.query.activityId);
            if(!resp.data.Data.find(value=>value == 'mobile')){
                resp.data.Data.push('mobile');
            }
            this.hiddenFields = resp.data.Data;

        },
        methods:{
            onClickLeft() {
                this.$router.go(-1);
            },
        }
    };

</script>
<style scoped>
    .header {
        height:120px;
    }
    .van-nav-bar__left i {
        font-size:1.5rem;
    }
    .van-nav-bar__left {
        height:100%;
    }
    .form-box {
        margin-top: 120px;
    }

</style>
